import Container from './components/Container';
import Manager from './components/Manager';

export const AlertContainer = Container;
export const alert = Manager;
